import {Box, Card, CardActionArea, CardContent, Divider, Grid, Typography} from "@mui/material";
import {ShortCargo} from "~/apps/packages/cargos/queries";
import {BorderedBox} from "~/apps/core/ui/BorderedBox";
import {Tag} from "~/apps/core/ui/Tag";
import {humanizeCargoTag} from "~/apps/packages/cargos/utils";
import {TypographyWithLabel} from "~/apps/core/ui/TypographyWithLabel";
import moment from "moment";
import React from "react";
import {CargoStatusBadge} from "~/apps/packages/cargos/CargoStatusBadge";
import {NavigateNext} from "@mui/icons-material";
import {TypographyWithIcon} from "~/apps/core/ui/TypographyWithIcon";


export type CargoListItemProps = {
    cargo: ShortCargo
    disableDetailButton?: boolean
}

export const CargoListItem = (props: CargoListItemProps) => {
    const {cargo, disableDetailButton} = props;
    return (
        <Card style={{width: "100%"}}>
            <CardActionArea disabled={disableDetailButton}>
                <CardContent>
                    <Grid container direction="column" rowSpacing="8px">
                        <Grid item>
                            <CargoStatusBadge>
                                {cargo.status}
                            </CargoStatusBadge>
                        </Grid>
                        <Grid item>
                            <Box paddingBottom="8px" display="flex">
                                <Typography variant="cardTitle1">
                                    {cargo.container?.number || cargo.label || "Груз без маркировки"}
                                </Typography>
                                {cargo.container && (
                                    <BorderedBox marginLeft="8px" variant="cardText">
                                        {cargo.container.type}
                                    </BorderedBox>
                                )}
                            </Box>
                            <Typography variant="tagsText" display="block" component="div" color="secondary">
                                {cargo.description}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Grid container spacing="8px">
                                {Object.entries(cargo.tags || {}).filter(([key, value]) => value).map(([key, value]) => (
                                    <Grid item key={key}>
                                        <Tag>
                                            {humanizeCargoTag(key as any)}
                                        </Tag>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Divider/>
                        </Grid>
                        <Grid item>
                            <TypographyWithLabel label={cargo.arrival.document.type} noWrap={false}>
                                {cargo.arrival?.document?.number} от {moment(cargo.arrival.document.date).format("DD MMM YYYY")}
                            </TypographyWithLabel>
                        </Grid>
                        <Grid item container direction="row" spacing="16px" wrap="nowrap" alignItems="flex-end">
                            <Grid item>
                                <TypographyWithLabel label="Прибытие">
                                    {cargo.arrival.date ? moment(cargo.arrival.date).format("DD MMM YYYY") : <>&ndash;</>}
                                </TypographyWithLabel>
                            </Grid>
                            <Grid item>
                                <TypographyWithLabel label="Убытие">
                                    {cargo.departure.date ? moment(cargo.departure.date).format("DD MMM YYYY") : <>&ndash;</>}
                                </TypographyWithLabel>
                            </Grid>
                            {!disableDetailButton && (
                                <Grid item textAlign="end" flexGrow={1}>
                                    <TypographyWithIcon endIcon={<NavigateNext/>} color="textSecondary" variant="cardText" marginRight="-8px" marginBottom="-2px">
                                        Подробнее
                                    </TypographyWithIcon>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </CardContent>
            </CardActionArea>
        </Card>
    )
}